import { useAppDispatch } from 'dux/app/hooks';

import { Box, Text } from '@prose-ui';

import Carousel from 'Components/Carousel';
import { Image } from 'Components/Image';

import { beforeAndAfterContent } from 'assets/content/densitySetLandingPage';

import useResponsiveVariant from 'utils/useResponsiveVariant';

import { trackHeapEvent } from 'dux/tracking/actions';

export const BeforeAndAfter = () => {
  const { isMobile, isTablet } = useResponsiveVariant();
  const dispatch = useAppDispatch();
  return (
    <Box
      alignItems={{ desktop: 'center' }}
      backgroundColor="neutral.200"
      display="flex"
      flexDirection="column"
      gap={{ desktop: '8x', mobile: '6x' }}
      paddingY={{ desktop: '30x', mobile: '15x' }}
      w="full"
    >
      <Text as="h2" fontWeight="light" paddingX={{ mobile: '6x' }} variant={isMobile ? 'h3' : 'h2'}>
        Results you can see, {isMobile && <br />} fullness you can feel
      </Text>

      <Carousel
        arrows={false}
        hasControlsPadding={false}
        onAfterChange={() => dispatch(trackHeapEvent('Before After Module Carousel Scroll'))}
        sectionsTitlesControl={beforeAndAfterContent.hairResults.map(({ header }) => header)}
        width={isMobile || isTablet ? '100%' : '870px'}
      >
        {beforeAndAfterContent.hairResults.map(({ image, imageAlt, title, disclaimer }) => (
          <Box
            key={image.desktop.src}
            display="flex"
            flexDirection="column"
            gap={isMobile ? '6x' : '8x'}
            paddingBottom={{ desktop: '4x', mobile: '6x' }}
            paddingTop={{ desktop: '8x', mobile: '6x' }}
          >
            <Box>
              <Image
                alt={imageAlt}
                src={isMobile ? image.mobile : image.desktop}
                style={{ display: 'block', width: '100%', height: 'auto' }}
              />
            </Box>
            <Box
              alignItems={{ desktop: 'center' }}
              display="flex"
              flexDirection="column"
              gap={isMobile ? '6x' : '10x'}
              paddingX={{ mobile: '6x' }}
            >
              <Text color="primary.300" variant={isMobile ? 'body3regular' : 'body1regular'}>
                {title}
              </Text>
              <Text color="primary.300" variant={isMobile ? 'body5regular' : 'body3regular'}>
                {disclaimer}
              </Text>
            </Box>
          </Box>
        ))}
      </Carousel>
    </Box>
  );
};
